import stringUtilities from './stringUtilities';
import postal from 'postal';

export default function useApi() {

    const IsProduction = window.top.location.host.toLowerCase() === "app.terraflow.ca" || window.top.location.host.toLowerCase() === "prd-terraflow-app.azurewebsites.net";
    const ApiBaseUrl = IsProduction ? "https://api.terraflow.ca" : "https://stg-terraflow-api.azurewebsites.net";
    const LoginBaseUrl = IsProduction ? "https://auth.terraflow.ca/account/log-in?returnUrl=" : "https://stg-terraflow-auth.azurewebsites.net/account/log-in?returnUrl=";
    const LogoutBaseUrl = IsProduction ? "https://auth.terraflow.ca/account/logout?returnUrl=" : "https://stg-terraflow-auth.azurewebsites.net/account/logout?returnUrl=";
    const ChangePasswordBaseUrl = IsProduction ? "https://auth.terraflow.ca/account/change-password" : "https://stg-terraflow-auth.azurewebsites.net/account/change-password";

    const getRendererApiKey = function () {
        return localStorage.getItem('rendererApiKey') || '';
    };

    const getAuthHeaders = function () {
        if (window.__isPlaywright === true) {
            return { 'X-Renderer-Key': getRendererApiKey() };
        }
        return { 'Authorization': 'Bearer ' + getToken() };
    };

    const applyAuthHeaders = function (xhr) {
        Object.entries(getAuthHeaders()).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    };

    const getToken = function () {
        let token = localStorage.getItem("token");
        if (!stringUtilities.isNullOrEmpty(token)) {
            return token;
        }
        if (window.__isPlaywright === true) {
            return '';
        }
        redirectToLogin();
    };

    const getReturnUrl = function () {
        let returnUrl = window.top.location.href;
        if (returnUrl.indexOf("#") > -1) {
            returnUrl = returnUrl.substring(0, returnUrl.indexOf("#"));
        }

        return returnUrl;
    };

    const redirectToLogin = function () {

        window.top.location = `${LoginBaseUrl}${getReturnUrl()}`;
    }

    const redirectToLogout = function () {

        window.top.location = `${LogoutBaseUrl}${getReturnUrl()}`
    }

    const redirectToChangePassword = function () {

        window.top.location = ChangePasswordBaseUrl;
    }

    const handleErrors = function (response) {

        if (response.status === 401) {
            throw Error(`API Error (${response.statusText}) at ${response.url}`);
        }

        if(response.status === 400) {            
            return response.json()
            .then(body => {
                const message = body?.isError && body?.errorMessage ? body.errorMessage : ``;
                throw Error(`- ${message}.`);
            })
            .catch((error) => {
                throw Error(`API Error (${response.status} ${response.statusText}) ${error?.message} ${response.url}`);
            });
        }

        if (!response.ok) {
            throw Error(`API Error (${response.status} ${response.statusText}) at ${response.url}`);
        }

        return response;
    };

    const fetchGet = function (url, onSuccess, onError, suppressErrorModal) {

        fetch(ApiBaseUrl + url, {
            method: 'GET',
            headers: getAuthHeaders()
        })
            .then(response => response.json())
            .then(data => {
                if (data.isError) {
                    return onRejected(new Error(data.errorMessage), onError, suppressErrorModal);
                }
                return onFulfilled(data, onSuccess);
            })
            .catch((error) => onRejected(error, onError, suppressErrorModal));
    };

    const fetchDelete = function (url, onSuccess, onError, suppressErrorModal) {
        fetchDeleteWithBody(url, null, onSuccess, onError, suppressErrorModal);
    };

    const fetchDeleteWithBody = function (url, body, onSuccess, onError, suppressErrorModal) {

        fetch(ApiBaseUrl + url, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                ...getAuthHeaders()
            },
            body: JSON.stringify(body),
            redirect: 'follow'
        })
            .then(handleErrors)
            .then(response => {
                const contentType = response.headers.get('content-type');
                return (contentType && contentType.includes('application/json')) ? response.json() : response;
            })
            .then(data => onFulfilled(data, onSuccess))
            .catch((error) => onRejected(error, onError, suppressErrorModal));
    };

    const fetchPatch = function (url, body, onSuccess, onError, suppressErrorModal) {

        let requestOptions = {
            method: 'PATCH',
            headers: {
                "Content-Type": "application/json",
                ...getAuthHeaders()
            },
            body: JSON.stringify(body),
            redirect: 'follow'
        };

        if (onSuccess) {
            fetch(ApiBaseUrl + url, requestOptions)
                .then(handleErrors)
                .then(response => response.json())
                .then(data => onFulfilled(data, onSuccess))
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        } else {
            fetch(ApiBaseUrl + url, requestOptions)
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        }
    };

    const fetchPost = function (url, body, signal, onSuccess, onError, suppressErrorModal) {

        let requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                ...getAuthHeaders()
            },
            body: JSON.stringify(body),
            redirect: 'follow'
        };

        if (signal !== null) {
            requestOptions.signal = signal
        }

        if (onSuccess) {
            fetch(ApiBaseUrl + url, requestOptions)
                .then(handleErrors)
                .then(response => {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return response.json();
                    } else {
                        return response.text();
                    }
                })
                .then(data => {
                    if (data.isError) {
                        return onRejected(new Error(data.errorMessage), onError, suppressErrorModal);
                    }
                    return onFulfilled(data, onSuccess);
                })
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        } else {
            fetch(ApiBaseUrl + url, requestOptions)
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        }
    };


    const fetchPostForBlob = function (url, body, onSuccess, onError, suppressErrorModal) {

        var filename;

        let requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                ...getAuthHeaders()
            },
            body: JSON.stringify(body),
            redirect: 'follow'
        };

        if (onSuccess) {
            fetch(ApiBaseUrl + url, requestOptions)
                .then(handleErrors)
                .then(function (response) {
                    if (response.ok) {
                        let contentDisposition = response.headers.get("content-disposition");
                        let contentDispositionParts = contentDisposition.split(";");
                        let filenameElement = contentDispositionParts.find(x => x.indexOf("filename=") > 0);

                        if (filenameElement) {
                            filename = filenameElement.split("=")[1];
                        }

                        response.blob().then(function (blob) {
                            if (onSuccess) {
                                onSuccess(blob, filename);
                            }
                        });
                    } else {
                        response.json().then(function (error) {
                            onRejected(new Error(error.errorMessage), onError, suppressErrorModal);
                        });
                    }
                }).catch((error) => onRejected(error, onError, suppressErrorModal));
        } else {
            fetch(ApiBaseUrl + url, requestOptions)
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        }
    };

    const fetchPostForFileUpload = function (url, formData, signal, onSuccess, onError, suppressErrorModal) {

        let requestOptions = {
            method: 'POST',
            headers: getAuthHeaders(),
            body: formData,
            redirect: 'follow'
        };

        if (signal !== null) {
            requestOptions.signal = signal
        }

        if (onSuccess) {
            fetch(ApiBaseUrl + url, requestOptions)
                .then(handleErrors)
                .then(response => {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return response.json();
                    } else {
                        return response.text();
                    }
                })
                .then(data => {
                    if (data.isError) {
                        return onRejected(new Error(data.errorMessage), onError, suppressErrorModal);
                    }
                    return onFulfilled(data, onSuccess);
                })
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        } else {
            fetch(ApiBaseUrl + url, requestOptions)
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        }
    };

    const fetchPut = function (url, body, onSuccess, onError, suppressErrorModal) {

        let requestOptions = {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                ...getAuthHeaders()
            },
            body: JSON.stringify(body),
            redirect: 'follow'
        };

        if (onSuccess) {
            fetch(ApiBaseUrl + url, requestOptions)
                .then(handleErrors)
                .then(response => response.json())
                .then(data => onFulfilled(data, onSuccess))
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        } else {
            fetch(ApiBaseUrl + url, requestOptions)
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        }
    };

    const fetchPutForFileUpload = function (url, file, onSuccess, onError, suppressErrorModal) {

        let requestOptions = {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: file,
            redirect: 'follow'
        };

        if (onSuccess) {
            fetch(ApiBaseUrl + url, requestOptions)
                .then(handleErrors)
                .then(response => response.json())
                .then(data => onFulfilled(data, onSuccess))
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        } else {
            fetch(ApiBaseUrl + url, requestOptions)
                .catch((error) => onRejected(error, onError, suppressErrorModal));
        }
    };

    const onFulfilled = function (data, onSuccess) {
        if (onSuccess) {
            onSuccess(data);
        }
    };

    const onRejected = function (error, onError, suppressErrorModal) {

        if (!suppressErrorModal) {
            postal.publish({
                channel: "error",
                topic: "thrown",
                data: {
                    error
                }
            });
        }

        if (onError) {
            onError(error);
        }
    };

    return {
        api: {
            setToken(token) {
                localStorage.setItem("token", token);
            },

            signout() {
                localStorage.setItem("token", "");
                redirectToLogout();
            },

            changePassword() {
                redirectToChangePassword();
            },

            /* USERS */
            getUser(onSuccess, onError) {
                fetchGet('/api/user', onSuccess, () => {
                    if (onError) {
                        onError();
                    }

                    redirectToLogin();
                }, true);
            },

            userAcceptTerms(onSuccess, onError) {
                fetchPost("/api/user/accept-terms", null, null, onSuccess, onError);
            },

            getUsers(organisationId, includeDeleted, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/users?includeDeleted=${includeDeleted}`, onSuccess, onError);
            },

            getUserById(organisationId, userId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/users/${userId}`, onSuccess, onError);
            },

            deleteUser(organisationId, userId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/users/${userId}`, onSuccess, onError);
            },

            patchUser(organisationId, userId, disabled, deleted, onSuccess, onError) {
                fetchPatch(`/api/${organisationId}/users/${userId}`, { disabled, deleted }, onSuccess, onError);
            },

            addUser(organisationId, firstName, lastName, emailAddress, roleId, sids, capabilityIds, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/users`, { firstName, lastName, emailAddress, roleId, sids, capabilityIds }, null, onSuccess, onError);
            },

            editUser(userId, organisationId, firstName, lastName, emailAddress, organisationalUnitId, disabled, roleId, sids, capabilityIds, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/users/${userId}`, { firstName, lastName, emailAddress, organisationalUnitId, disabled, roleId, sids, capabilityIds }, onSuccess, onError)
            },

            resetPassword(userId, organisationId, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/users/${userId}/reset-password`, null, null, onSuccess, onError, true)
            },

            /* ORGANISATIONAL UNITS */
            getOrganisationalUnits(includeDeleted, onSuccess, onError) {
                fetchGet(`/api/organisational-units/?includeDeleted=${includeDeleted}`, onSuccess, onError);
            },

            createOrganisationalUnit(parentOrganisationalUnitId, name, disabled, createShard, onSuccess, onError) {
                fetchPost(`/api/organisational-units`, {parentOrganisationalUnitId, name, disabled, createShard}, null, onSuccess, onError)
            },

            deleteOrganisationalUnit(orgId, onSuccess, onError) {
                fetchDelete(`/api/organisational-units/${orgId}`, onSuccess, onError, true);
            },

            permanentlyDeleteOrganisationalUnit(orgId, onSuccess, onError) {
                fetchDelete(`/api/organisational-units/${orgId}?hardDelete=true`, onSuccess, onError, true);
            },

            updateOrganisationalUnit(updateOrg, name, onSuccess, onError) {
                fetchPut(`/api/organisational-units/${updateOrg.id}`, {name, disabled: updateOrg.disabled}, onSuccess, onError)
            },

            getOrganisationalUnit(organisationalUnitId, onSuccess, onError) {
                fetchGet(`/api/organisational-units/${organisationalUnitId}`, onSuccess, onError);
            },

            deleteOrganisationProperty(organisationalUnitId, propertyName, onSuccess, onError) {
                fetchDelete(`/api/organisational-units/${organisationalUnitId}/${propertyName}`, onSuccess, onError)
            },
            
            updateOrganisationFile(organisationalUnitId, file, propertyName, onSuccess, onError) {
                const payload = new FormData();
                payload.append('File', file);

                const xhr = new XMLHttpRequest();

                xhr.upload.onerror = (e) => {
                    if (onError) {
                        onError(e);
                    }
                };

                xhr.onreadystatechange = function () {

                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            if (onSuccess) {

                                let result = JSON.parse(xhr.response);
                                onSuccess(result);
                            }
                        } else {
                            if (onError) {
                                onError();
                            }
                        }
                    }
                };

                xhr.open('PUT', ApiBaseUrl + `/api/organisational-units/${organisationalUnitId}/${propertyName}`, true);
                applyAuthHeaders(xhr);
                xhr.send(payload);
            },
            /*  Api KEYS */
            getApiKeys(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/api-keys`, onSuccess, onError, true);
            },

            addApiKey(organisationId, name, role, expiresAt, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/api-keys`, { name, role, expiresAt, }, null, onSuccess, onError);
            },

            revokeApiKey(organisationId, apiKeyId, onSuccess, onError) {
                fetchPatch(`/api/${organisationId}/api-keys/${apiKeyId}/revoke`, null, onSuccess, onError, true)
            },

            updateApiKey(organisationId, apiKeyId, name, role, expiresAt, isActive, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/api-keys/${apiKeyId}`, { name, role, expiresAt, isActive }, onSuccess, onError);
            },

            /* PROJECTS */
            getProjects(organisationId, onSuccess, onError, includeDeleted) {
                fetchGet(`/api/${organisationId}/projects${includeDeleted ? "?includeDeleted=true" : ""}`, onSuccess, onError, true);
            },

            addProject(organisationId, name, longitude, latitude, syncDataDays, configuration, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects`, { name, longitude, latitude, syncDataDays, configuration }, null, onSuccess, onError);
            },

            editProject(organisationId, projectId, name, longitude, latitude, syncDataDays, configuration, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/projects/${projectId}`, { name, longitude, latitude, syncDataDays, configuration }, onSuccess, onError);
            },

            deleteProject(organisationId, projectId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/projects/${projectId}`, onSuccess, onError);
            },

            copyProject(organisationId, projectId, name, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects/${projectId}/copy`, { name }, null, onSuccess, onError);
            },

            unDeleteProject(organisationId, projectId, deleted, onSuccess, onError) {
                fetchPatch(`/api/${organisationId}/projects/${projectId}`, { deleted }, onSuccess, onError)
            },

            /* JOBS */

            addJob(organisationId, projectId, name, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects/${projectId}/jobs`, { name }, null, onSuccess, onError);
            },

            editJob(organisationId, projectId, jobId, name, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/projects/${projectId}/jobs/${jobId}`, { name }, onSuccess, onError);
            },

            mergeJob(organisationId, projectId, jobId, targetJobId, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects/${projectId}/jobs/${jobId}`, { targetJobId }, null, onSuccess, onError);
            },

            getJobs(organisationId, projectId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/jobs`, onSuccess, onError);
            },

            getProject(organisationId, projectId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}`, onSuccess, onError);
            },

            deleteJob(organisationId, projectId, jobId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/projects/${projectId}/jobs/${jobId}`, onSuccess, onError);
            },

            /* SKETCHES */
            getSketches(organisationId, projectId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/sketches`, onSuccess, onError);
            },

            getSketch(organisationId, projectId, sketchId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/sketches/${sketchId}`, onSuccess, onError);
            },

            addSketch(organisationId, projectId, name, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects/${projectId}/sketches`, { name }, null, onSuccess, onError, true);
            },

            saveSketch(organisationId, projectId, sketchId, sketch, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/projects/${projectId}/sketches/${sketchId}`, sketch, onSuccess, onError, true);
            },

            deleteSketch(organisationId, projectId, sketchId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/projects/${projectId}/sketches/${sketchId}`, onSuccess, onError);
            },

            sendMapPackage(organisationId, projectId, sketchId, outputFormat, selections, basemap, includeDeleted, surfaceIds, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects/${projectId}/sketches/${sketchId}/map-package`, { outputFormat, selections, basemap, includeDeleted, surfaceIds }, null, onSuccess, onError);
            },

            /* WORKFLOWS */
            getWorkflows(organisationId, projectId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/workflows`, onSuccess, onError);
            },

            getWorkflow(organisationId, projectId, workflowId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/workflows/${workflowId}`, onSuccess, onError);
            },

            getWorkflowTemplates(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/workflow-templates`, onSuccess, onError);
            },

            getWorkflowTemplate(organisationId, workflowTemplateId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/workflow-templates/${workflowTemplateId}`, onSuccess, onError);
            },

            addWorkflow(organisationId, projectId, name, orderBy, configuration, workflowType, hue, colour, workflowTemplateId, isComposite, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/projects/${projectId}/workflows`, { name, orderBy, configuration, workflowType, hue, colour, workflowTemplateId, isComposite }, null, onSuccess, onError, true);
            },

            editWorkflow(organisationId, projectId, workflowId, name, orderBy, configuration, workflowType, hue, colour, workflowTemplateId, isComposite, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/projects/${projectId}/workflows/${workflowId}`, { name, orderBy, configuration, workflowType, hue, colour, workflowTemplateId, isComposite }, onSuccess, onError);
            },

            deleteWorkflow(organisationId, projectId, workflowId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/projects/${projectId}/workflows/${workflowId}`, onSuccess, onError);
            },

            addWorkflowTemplate(organisationId, name, orderBy, configuration, workflowTypeId, hue, color, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/workflow-templates`, { name, orderBy, configuration, workflowTypeId, hue, color }, null, onSuccess, onError, true);
            },

            editWorkflowTemplate(organisationId, workflowTemplateId, name, orderBy, configuration, workflowType, hue, color, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/workflow-templates/${workflowTemplateId}`, { name, orderBy, configuration, workflowType, hue, color }, onSuccess, onError);
            },

            /* Icons */
            getIcons(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/icons`, onSuccess, onError);
            },

            getIconsForOrganisation(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/icons/organisation`, onSuccess, onError);
            },

            addIcon(organisationId, parentFolderPath, name, svg, onSuccess, onError) {
                const filename = name.toLowerCase().endsWith('.svg') ? name : `${name}.svg`;
                const formData = new FormData();
                formData.append('File', svg, filename);
                formData.append('ParentFolderPath', parentFolderPath ?? '');
                fetchPostForFileUpload(`/api/${organisationId}/icons`, formData, null, onSuccess, onError);
            },

            /* KML Files */
            getKmlFiles(organisationId, projectId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/kml-files`, onSuccess, onError)
            },

            getKmlFile(organisationId, projectId, kmlFileId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/kml-files/${kmlFileId}`, onSuccess, onError)
            },

            addKmlFile(organisationId, projectId, file, onSuccess, onError) {
                fetchPostForFileUpload(`/api/${organisationId}/projects/${projectId}/kml-files`, file, null, onSuccess, onError, true)
            },

            deleteKmlFile(organisationId, projectId, kmlFileId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/projects/${projectId}/kml-files/${kmlFileId}`, onSuccess, onError, true);
            },

            /* Surfaces */
            getSurfaces(organisationId, projectId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/surfaces`, onSuccess, onError)
            },

            getSurface(organisationId, projectId, surfaceId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/surfaces/${surfaceId}`, onSuccess, onError)
            },

            addSurface(organisationId, projectId, file, onSuccess, onError) {
                fetchPostForFileUpload(`/api/${organisationId}/projects/${projectId}/surfaces`, file, null, onSuccess, onError, true)
            },

            editSurface(organisationId, projectId, surfaceId, file, onSuccess, onError) {
                fetchPutForFileUpload(`/api/${organisationId}/projects/${projectId}/surfaces/${surfaceId}`, file, onSuccess, onError, true)
            },

            deleteSurface(organisationId, projectId, surfaceId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/projects/${projectId}/surfaces/${surfaceId}`, onSuccess, onError, true);
            },

            /* DATA */
            getData(organisationId, projectId, jobIds, userIds, workflowIds, topLat, bottomLat, leftLng, rightLng, dateFrom, dateTo, timeOffset, exportFormat, srid, includePhotos, pageNumber, includeDeleted, signal, onSuccess, onError, pageSize) {

                let payload = { jobIds, userIds, workflowIds, topLat, bottomLat, leftLng, rightLng, dateFrom, dateTo, timeOffset, exportFormat, srid, includePhotos, pageNumber, includeDeleted, pageSize };

                fetchPost(`/api/${organisationId}/projects/${projectId}/data`, payload, signal, onSuccess, onError, exportFormat === 0);
            },

            getPoint(organisationId, projectId, pointId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/points/${pointId}`, onSuccess, onError, true)
            },

            deletePoint(organisationId, projectId, pointId, deleteMode, onSuccess, onError) {
                fetchDeleteWithBody(`/api/${organisationId}/projects/${projectId}/points/${pointId}`, { deleteMode }, onSuccess, onError, true)
            },

            unDeletePoint(organisationId, projectId, pointId, onSuccess, onError) {
                fetchPatch(`/api/${organisationId}/projects/${projectId}/points/${pointId}/undelete`, {}, onSuccess, onError, true)
            },

            unDeleteGeometry(organisationId, projectId, geometryId, onSuccess, onError) {
                fetchPatch(`/api/${organisationId}/projects/${projectId}/geometries/${geometryId}/undelete`, {}, onSuccess, onError, true)
            },

            updatePointAttributes(organisationId, currentProjectId, newProjectId, pointId, workflowId, formData, jobId, gpsData, sensorData, photos, attachments, onSuccess, onError, applyToLine = true) {
                const jsonString = JSON.stringify(formData)
                const body = { workflowId, formData: jsonString, jobId, projectId: newProjectId, gpsData: null, sensorData: null, photos: null, attachments: null, applyToLine }
                fetchPatch(`/api/${organisationId}/projects/${currentProjectId}/points/${pointId}`, body, onSuccess, onError, false)
            },

            moveMultiplePoints(organisationId, projectId, pointIds, workflowId, jobId, targetProjectId, onSuccess, onError) {
                fetchPatch(`/api/${organisationId}/projects/${projectId}/points`, { pointIds, workflowId, jobId, projectId: targetProjectId }, onSuccess, onError)
            },

            createPoint(organisationId, projectId, workflowId, formData, jobId, gpsData, sensorData, photos, attachments, geometryType, lineId, onSuccess, onError) {
                const body = {workflowId, jobId, projectId, geometryType, lineId, formData: JSON.stringify(formData), gpsData: JSON.stringify(gpsData, stringUtilities.jsonPropertiesFirstCharacterToUppercase), sensorData: JSON.stringify(sensorData, stringUtilities.jsonPropertiesFirstCharacterToUppercase), photos: JSON.stringify(photos), attachments}

                fetchPost(`/api/${organisationId}/projects/${projectId}/points`, body, null, onSuccess, onError, true)
            },

            /* STAMPS */
            getStamps(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/stamps`, onSuccess, onError);
            },

            addStamp(organisationId, name, svg, tagIds, onSuccess, onError) {
                const payload = new FormData();
                payload.append('Name', name);
                payload.append('Stamp', svg);
                payload.append('TagIds', tagIds);

                const xhr = new XMLHttpRequest();

                xhr.upload.onerror = (e) => {
                    if (onError) {
                        onError(e);
                    }
                };

                xhr.onreadystatechange = function () {

                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            if (onSuccess) {

                                let result = JSON.parse(xhr.response);
                                onSuccess(result);
                            }
                        } else {
                            if (onError) {
                                onError();
                            }
                        }
                    }
                };

                xhr.open('POST', ApiBaseUrl + `/api/${organisationId}/stamps`, true);
                applyAuthHeaders(xhr);
                xhr.send(payload);
            },


            editStamp(organisationId, stampId, name, svg, tagIds, onSuccess, onError) {
                const payload = new FormData();
                payload.append('Name', name);
                payload.append('Stamp', svg);
                payload.append('TagIds', tagIds);

                const xhr = new XMLHttpRequest();

                xhr.upload.onerror = (e) => {
                    if (onError) {
                        onError(e);
                    }
                };

                xhr.onreadystatechange = function () {

                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            if (onSuccess) {

                                let result = JSON.parse(xhr.response);
                                onSuccess(result);
                            }
                        } else {
                            if (onError) {
                                onError();
                            }
                        }
                    }
                };

                xhr.open('PUT', ApiBaseUrl + `/api/${organisationId}/stamps/${stampId}`, true);
                applyAuthHeaders(xhr);
                xhr.send(payload);
            },

            deleteStamp(organisationId, stampId, onSuccess, onError) {
                fetchDelete(`/api/${organisationId}/stamps/${stampId}`, onSuccess, onError)
            },

            /* BLUETOOTH CONSOLES */

            getConsoles(query, from, to, organizationalUnitId, page, onSuccess, onError) {
                fetchPost("/api/bluetooth-consoles/search", { query, from, to, organizationalUnitId, page }, null, onSuccess, onError, true)
            },

            deleteConsole(bluetoothConsoleId, onSuccess, onError) {
                fetchDelete(`/api/bluetooth-consoles/${bluetoothConsoleId}`, onSuccess, onError)
            },

            deleteMultipleConsoles(bluetoothConsoleIds, onSuccess, onError) {
                fetchDeleteWithBody("/api/bluetooth-consoles", bluetoothConsoleIds, onSuccess, onError)
            },

            /* Licenses */
            getLicenses(sortBy, sortDirection, exportFormat, organisationId, renewalDateStart, renewalDateEnd, includeDeleted, pageNumber, unassignedOnly, sid, signal, onSuccess, onError) {
                const body = { sortBy, sortDirection, exportFormat, organisationId, renewalDateStart, renewalDateEnd, includeDeleted, pageNumber, unassignedOnly, sid }
                if (exportFormat === 0) {
                    fetchPost("/api/licenses/search", body, signal, onSuccess, onError, true)
                } else if (exportFormat === 3) {
                    fetchPostForBlob("/api/licenses/search", body, onSuccess, onError, true)
                }

            },

            getLicense(sid, onSuccess, onError) {
                fetchGet(`/api/licenses/${sid}`, onSuccess, onError, true)
            },

            addLicense(organisationalUnitId, userId, skuId, role, billTo, renewalDate, adminEmail, quantity, onSuccess, onError) {
                fetchPost("/api/licenses", { organisationalUnitId, userId, skuId, role, billTo, renewalDate, adminEmail, quantity }, null, onSuccess, onError, true)
            },

            editLicense(sid, organisationalUnitId, userId, skuId, role, billTo, renewalDate, adminEmail, onSuccess, onError) {
                fetchPut(`/api/licenses/${sid}`, { organisationalUnitId, userId, skuId, role, billTo, renewalDate, adminEmail }, onSuccess, onError, true)
            },

            editMultiLicenses(sids, billTo, renewalDate, adminEmail, onSuccess, onError) {
                fetchPatch("/api/licenses", { sids, billTo, renewalDate, adminEmail }, onSuccess, onError, true)
            },

            deleteLicense(sid, onSuccess, onError) {
                fetchDelete(`/api/licenses/${sid}`, onSuccess, onError, true)
            },

            deleteMultiLicenses(sids, onSuccess, onError) {
                fetchDeleteWithBody("/api/licenses", { sids }, onSuccess, onError, true)
            },

            unDeleteLicense(sid, onSuccess, onError) {
                fetchPatch(`/api/licenses/${sid}/undelete`, null, onSuccess, onError, true)
            },

            unDeleteMultiLicenses(sids, onSuccess, onError) {
                fetchPatch("/api/licenses/undelete", { sids }, onSuccess, onError, true)
            },

            disableLicense(sid, onSuccess, onError) {
                fetchPatch(`/api/licenses/${sid}/disable`, null, onSuccess, onError, true)
            },

            disableMultiLicenses(sids, onSuccess, onError) {
                fetchPatch("/api/licenses/disable", { sids }, onSuccess, onError, true)
            },

            enableLicense(sid, onSuccess, onError) {
                fetchPatch(`/api/licenses/${sid}/enable`, null, onSuccess, onError)
            },

            enableMultiLicenses(sids, onSuccess, onError) {
                fetchPatch("/api/licenses/enable", { sids }, onSuccess, onError)
            },

            /* SKUs */
            fetchAllSkus(onSuccess, onError) {
                fetchGet("/api/skus", onSuccess, onError)
            },

            fetchSkusByProduct(product, onSuccess, onError) {
                fetchPost("/api/skus/search", { product }, null, onSuccess, onError, true)
            },

            fetchSkuById(skuId, onSuccess, onError) {
                fetchGet(`/api/skus/${skuId}`, onSuccess, onError)
            },

            addSku(id, product, onSuccess, onError) {
                fetchPost("/api/skus", { id, product }, null, onSuccess, onError, true)
            },

            editSku(id, product, onSuccess, onError) {
                fetchPut("/api/skus", { id, product }, onSuccess, onError, true)
            },

            deleteSku(skuId, onSuccess, onError) {
                fetchDelete(`/api/skus/${skuId}`, onSuccess, onError, true)
            },

            /* TAGS */
            getTags(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/tags`, onSuccess, onError);
            },

            addTag(organisationId, name, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/tags`, { name }, null, onSuccess, onError);
            },

            /* TELUS REPORTS */
            requestTelusReport(organisationId, projectId, sketchId, language, requestNumber, basemap, selections, limitDetails, includeDeleted, selectedSurfaceIds, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/telus-reports`, { projectId, sketchId, language, requestNumber, basemap, selections, limitDetails, includeDeleted, selectedSurfaceIds }, null, onSuccess, onError);
            },

            searchTelusReports(organisationId, sketchId, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/telus-reports/search`, { sketchId }, null, onSuccess, onError);
            },

            /* ONTARIO LOCATE REPORTS */
            requestOntarioLocateReport(organisationId, projectId, sketchId, ticketNumber, configuration, basemap, selections, includeDeleted, selectedSurfaceIds, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/ontario-locate-reports`, { projectId, sketchId, ticketNumber, configuration, basemap, selections, includeDeleted, selectedSurfaceIds }, null, onSuccess, onError);
            },

            searchOntarioLocateReports(organisationId, sketchId, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/ontario-locate-reports/search`, { sketchId }, null, onSuccess, onError);
            },

            /* REPORTS */
            userActivityReport(organisationId, startDate, endDate, onSuccess, onError) {
                fetchPost(`/api/${organisationId}/reports/user-activity`, { startDate, endDate }, null, onSuccess, onError, true);
            },

            /* DOWNLOADS */
            searchDownloads(organisationId, filter, pageNumber, signal, onSuccess, onError, projectId = null, pageSize = null) {
                const body = { filter, pageNumber, projectId, pageSize };
                fetchPost(`/api/${organisationId}/downloads/search`, body, signal, onSuccess, onError, true);
            },

            getDownload(organisationId, taskType, taskId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/downloads/${taskType}/${taskId}`, onSuccess, onError, true);
            },

            /* SETTINGS */
            getDeviceManagementSettings(organisationId, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/settings/device-management`, onSuccess, onError, true);
            },

            /* IMPORT DATA */
            importDataAnalyze(organisationId, formData, onSuccess, onError) {
                fetchPostForFileUpload(`/api/${organisationId}/import-data/analyze`, formData, null, onSuccess, onError, true)
            },

            getEmptyPoint(organisationId, projectId, workflowId, type, onSuccess, onError) {
                fetchGet(`/api/${organisationId}/projects/${projectId}/points?workflowId=${workflowId}&type=${type}`, onSuccess, onError, true)
            },

            importDataPreview(organisationId, formData, onSuccess, onError) {
                fetchPostForFileUpload(`/api/${organisationId}/import-data/preview`, formData, null, onSuccess, onError, true)
            },

            importData(organisationId, formData, onSuccess, onError) {
                fetchPostForFileUpload(`/api/${organisationId}/import-data/import`, formData, null, onSuccess, onError, true)
            },

            saveDeviceManagementSettings(organisationId, saveAndMoreMode, autoSync, autoSyncFrequency, bluetoothWindow, audibleToneOnPointCollection, locationSource, locationTranslation, accuracyLimitEnabled, accuracyLimitCentimetres, onSuccess, onError) {
                fetchPut(`/api/${organisationId}/settings/device-management`, {
                    saveAndMoreMode, autoSync, autoSyncFrequency, bluetoothWindow, audibleToneOnPointCollection, locationSource, locationTranslation, accuracyLimitEnabled, accuracyLimitCentimetres
                }, onSuccess, onError);
            }
        }
    }
}